export enum EntitlementReportsProvidersEnum {
    NYSE,
    NASDAQ,
    NASDAQUTP,
    CBOE
}
